// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__c6dWA","modal":"Modal_modal__fgttZ","slide-down":"Modal_slide-down__hVMpG"};